import { BoxGroup } from "./box-group";

export class OrderBoxGroup {
    public id!: string;
    public boxModel: BoxGroup[] = [];
}